import React from "react";

// Local Imports
import mirrorcleWorld from "../../images/illustration/mirrorcle-world-ayumi-hamasaki.jpg";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function Ill_Project_2() {
  // Ayumi Hamasaki Portrait
  const openPopupBoxAyumiHamasakiPortrait = () => {
    const content = (
      <>
        <img
          className="portfolio-image-popupbox"
          src={mirrorcleWorld}
          alt="A digitally made painting of the japanese pop singer, Ayumi Hamasaki -
          referenced from one of her album covers: 'GREEN / Days'"
        />
        <p>
          A digitally made painting of the japanese pop singer, Ayumi Hamasaki -
          referenced from one of her album covers: "GREEN / Days"
        </p>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Ayumi Hamasaki Portrait - GREEN / Days album cover | Fanmade",
        },
      },
    });
  };

  const popupboxConfigAyumiHamasakiPortrait = {
    titleBar: {
      enable: true,
      text: "Ayumi Hamasaki Portrait - GREEN / Days album cover | Fanmade",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div
        className="portfolio-image-box"
        onClick={openPopupBoxAyumiHamasakiPortrait}
      >
        <img
          className="portfolio-image constraints image-middle-center"
          src={mirrorcleWorld}
          alt="Screenshot of Ayumi Hamasaki Portrait - GREEN / Days album cover"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigAyumiHamasakiPortrait} />
    </>
  );
}

export default Ill_Project_2;
